import { createSlice } from "@reduxjs/toolkit";

// Filtros de la navegabilidad de sesiones del terapeuta. El idTerapeuta es
// fijo (el usuario logueado) y no se muestra como filtro.
const initialState = {
    filters: {
        participante: "",
        fechaInicio: null,
        fechaFin: null,
    },
    results: [],
}

export const sesionTerapeutaSearchSlice = createSlice({
    name: "sesionTerapeutaSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
    },
});

export const { setValue, setResults } = sesionTerapeutaSearchSlice.actions;
export default sesionTerapeutaSearchSlice.reducer;
